import React from 'react'
import ResponseTable from './Response/ResponseTable'

const ResponsesIndex = () => {
  return (
    <ResponseTable />
  )
}

export default ResponsesIndex